import { AwsS3Publisher } from './AwsS3Publisher';

class GoogleCloudPublisher extends AwsS3Publisher {
  provider = 'gcp-gcs';
}

export { GoogleCloudPublisher };
